import React, { useEffect, useState } from "react";

const KaringanaInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallPrompt, setShowInstallPrompt] = useState(false);
  const [showIosInstructions, setShowIosInstructions] = useState(false);

  const isIos = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test(userAgent) && /safari/.test(userAgent);
  };

  const isInStandaloneMode = () =>
    "standalone" in window.navigator && window.navigator.standalone;

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallPrompt(true);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    if (isIos() && !isInStandaloneMode()) {
      setShowIosInstructions(true);
    }

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === "accepted") {
      setShowInstallPrompt(false);
      setDeferredPrompt(null);
    }
  };

  // Estilo overlay que bloqueia tudo atrás
  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.5)", // escurece fundo
    zIndex: 9998,
  };

  // Estilo centralizado do modal
  const boxStyle = {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "20px 25px",
    backgroundColor: "#66BB6A",
    color: "white",
    borderRadius: "15px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.3)",
    zIndex: 9999,
    maxWidth: "90vw",
    textAlign: "center",
    fontFamily: "sans-serif",
  };

  // Estilo para iOS com background amarelo
  const iosBoxStyle = { ...boxStyle, backgroundColor: "#FFEB3B", color: "#000" };

  if (showInstallPrompt) {
    return (
      <>
        <div style={overlayStyle} aria-hidden="true" />
        <div style={boxStyle} role="dialog" aria-modal="true" aria-labelledby="installPromptTitle">
          <p id="installPromptTitle" style={{ margin: 0, fontWeight: "bold", fontSize: "1rem" }}>
            Instale o Karingana no seu dispositivo!
          </p>
          <button
            onClick={handleInstallClick}
            style={{
              marginTop: "15px",
              padding: "10px 20px",
              backgroundColor: "#388E3C",
              color: "white",
              border: "none",
              borderRadius: "10px",
              cursor: "pointer",
              fontWeight: "bold",
              fontSize: "1rem",
            }}
          >
            Instalar Agora
          </button>
        </div>
      </>
    );
  }

  if (showIosInstructions) {
    return (
      <>
        <div style={overlayStyle} aria-hidden="true" />
        <div style={iosBoxStyle} role="dialog" aria-modal="true" aria-labelledby="iosInstructionsTitle">
          <p id="iosInstructionsTitle" style={{ margin: 0, fontWeight: "bold", fontSize: "1rem" }}>
            Instale o Karingana no iPhone:
          </p>
          <ol style={{ fontSize: "0.9rem", marginTop: "10px", paddingLeft: "18px", textAlign: "left" }}>
            <li>Toque em <strong>“Compartilhar”</strong> no Safari</li>
            <li>Escolha <strong>“Adicionar à Tela de Início”</strong></li>
          </ol>
        </div>
      </>
    );
  }

  return null;
};

export default KaringanaInstallPrompt;
